<template>
  <Main>
    <OfficeForm
      :form="form"
      @submit="submit"
      @cancel="previousPage"
      :is-edit="true"
      v-if="form"
      :text-button="'SALVAR'"
    />
    <ModalCancelOffice
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalCancelOffice from "../../insurance_company/components/ModalCancelInsurance";
import OfficeForm from "../components/OfficeForm";
import { normalizeCnpj } from "@/utils/documents.js";
import _ from "lodash";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristine) next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  data: () => ({
    form: null,
    modalCancel: false,
    cancel: false,
    nextRoute: null,
    cloneForm: null
  }),
  mixins: [LoadingRequest],
  components: {
    ModalCancelOffice,
    OfficeForm
  },
  created() {
    this.fetchOffice();
  },
  computed: {
    formIsPristine() {
      // Obrigado mask por facilitar minha vida ...
      const normalizeDocument = value => normalizeCnpj(value);
      return (
        _.isEqual(
          _.omit(this.form, ["cnpj"]),
          _.omit(this.cloneForm, ["cnpj"])
        ) &&
        normalizeDocument(this.form.cnpj) ===
          normalizeDocument(this.cloneForm.cnpj)
      );
    }
  },
  methods: {
    ...mapActions("office", [
      "requestOffice",
      "requestEditOffice",
      "requestListQuotation",
      "requestListPolicy"
    ]),
    async fetchOffice() {
      const payload = {
        escritorio_id: this.$route.params.id
      };
      await this.withLoading(
        Promise.all([
          this.requestListPolicy(payload),
          this.requestListQuotation(payload),
          this.requestOffice(this.$route.params.id).then(data => {
            this.form = data;
          })
        ])
      );
      this.cloneForm = _.cloneDeep(this.form);
    },
    submit(form) {
      const payload = {
        ...form,
        cnpj: normalizeCnpj(form.cnpj)
      };
      this.withLoading(
        this.requestEditOffice({
          id: this.$route.params.id,
          payload
        }).then(() => {
          this.showAlertNotification({
            message: "Escritório editado com sucesso",
            type: "success"
          });
          this.cancel = true;
          this.previousPage();
        })
      );
    },
    previousPage() {
      this.$router.push({ name: "office" });
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({ name: this.nextRoute.name });
      }
    }
  }
};
</script>
